import React from 'react'
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import CuentaSelected from "../../helpers/CuentaSelected";
import DonationsForm from "./DonationsForm";
import DonationsList from "./DonationsList";
import ChipUserAccount from "../../components/ChipUserAccount";
import {withRouter} from 'react-router';
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import Session from "../../helpers/Session";

class Donations extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            account: {},
            donationValue: '',
            donationList: [],
        };

        this.getDonations = this.getDonations.bind(this);
    }

    async componentDidMount() {
        this.setState({
            account: CuentaSelected.get()
        });
        this.getDonations();
    }

    getDonations = async () => {
        const account = CuentaSelected.get()
        const data = await Api.get(`${Env.UrlBackend}/donations/get?account=${account.cuentaCodigo}`);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            donationList: data.data
        });
    }

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value});
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        if (!this.validForm()) {
            return;
        }

        const account = CuentaSelected.get()
        const userLogged = Session.getLogin();

        const params = {
            account: account.cuentaCodigo,
            value: Number.parseInt(this.state.donationValue),
            email: userLogged.terceroMail,
            name: `${userLogged.terceroNombre1} ${userLogged.terceroNombre2} ${userLogged.terceroApellido1} ${userLogged.terceroApellido2}`,
        }
        const data = await Api.post(`${Env.UrlBackend}/donations/set`, params);
        AppToast(data.message, data.success);
        if (data.success) {
            await this.resetForm();
        }
    }

    validForm = () => {
        const value = String(this.state.donationValue).trim();
        if (value === '' || Number(value) === 0) {
            AppToast('Por favor ingrese el valor del aporte.', false);
            return false;
        }
        return true;
    }

    resetForm = async () => {
        this.setState({
            donationValue: '',
        });
        await this.getDonations();
    }

    render() {

        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Aporte Voluntario "Comparto mi Energía"'
                />

                <h2>
                    <ChipUserAccount/>
                    <span>Aporte Voluntario "Comparto mi Energía"</span>
                </h2>

                <DonationsForm
                    donationValue={this.state.donationValue}
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}
                />

                <DonationsList
                    data={this.state.donationList}
                    getDonations={this.getDonations}
                />

            </div>
        );
    }
}

export default withRouter(Donations)